import Styled from 'styled-components';

export const SubNavLinks = Styled.ul`
  display: flex;
  order: 2;
  flex: 1;
  justify-content: stretch;
  padding: 0;
  height: 100%;
`;
